<template>
  <RouterView @authenticated="setAuthenticated" />
  <GlobalNotifications />
</template>

<script lang="ts">
//import { RouterView } from "vue-router";
import GlobalNotifications from "@/components/GlobalNotifications.vue";
import { useAuthStore } from "@/store/authStore";

export default {
  name: "App",
  components: {
    GlobalNotifications,
  },
  data() {
    return {
      authenticated: false,
    };
  },
  mounted() {
    // Initialize authentication based on environment
    this.initializeAuth();

    if (!this.authenticated) {
      // this.$router.replace({ name: "login" });
    }
  },
  methods: {
    setAuthenticated(status: boolean) {
      this.authenticated = status;
    },
    async initializeAuth() {
      const authStore = useAuthStore();
      // Check if we're in development mode with Keycloak deactivated
      const isDevMode =
        import.meta.env.DEV &&
        JSON.parse(import.meta.env.VITE_KEYCLOAK_DEACTIVATED);

      if (isDevMode) {
        // In dev mode, authentication is already set up in the store's initial state
        console.log("Dev mode: Authentication bypassed, using mock user");
        console.log("Mock user role:", authStore.user?.userRole);
        this.authenticated = authStore.getAuthenticated;
      } else {
        // In production mode, initialize Keycloak if not already done
        console.log("Production mode: Checking Keycloak authentication...");

        try {
          // Get the Keycloak object (this will initialize it if needed)
          const keycloakObj = authStore.getKeycloakObj;

          // If Keycloak is already authenticated (e.g., from a previous session)
          if (keycloakObj && keycloakObj.authenticated) {
            authStore.storeLogin(keycloakObj, false); // false to not clear existing data
            await useAuthStore().retrieveUserData();

            this.authenticated = true;

            console.log(
              "User authenticated:",
              keycloakObj.tokenParsed?.preferred_username,
            );
          } else {
            console.log("User not authenticated");
            this.authenticated = false;
          }
        } catch (error) {
          console.error("Error initializing Keycloak:", error);
          this.authenticated = false;
        }
      }
    },
  },
};
</script>

<style scoped>
header {
  line-height: 1.5;
  max-height: 100vh;
}

.logo {
  display: block;
  margin: 0 auto 2rem;
}

nav {
  width: 100%;
  font-size: 12px;
  text-align: center;
  margin-top: 2rem;
}

nav a.router-link-exact-active {
  color: var(--color-text);
}

nav a.router-link-exact-active:hover {
  background-color: transparent;
}

nav a {
  display: inline-block;
  padding: 0 1rem;
  border-left: 1px solid var(--color-border);
}

nav a:first-of-type {
  border: 0;
}

@media (min-width: 1024px) {
  header {
    display: flex;
    place-items: center;
    padding-right: calc(var(--section-gap) / 2);
  }

  .logo {
    margin: 0 2rem 0 0;
  }

  header .wrapper {
    display: flex;
    place-items: flex-start;
    flex-wrap: wrap;
  }

  nav {
    text-align: left;
    margin-left: -1rem;
    font-size: 1rem;

    padding: 1rem 0;
    margin-top: 1rem;
  }
}
</style>
